<p>stats-reports works!</p>
